import React from "react";
import Slider from "react-slick";
import PropTypes from "prop-types";

import "./styles.scss";

import {
    Container,
    Row,
    Col
} from "reactstrap";

const Graduates = ({ graduates }) => {
    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 1000,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <Container fluid tag="section" className="graduates py-5">
            <Container>
                <Row>
                    <Col>
                        <h2 className="title">Egresados</h2>
                    </Col>
                </Row>
                <Row tag="article">
                    <Col>
                        <Slider {...settings}>
                            {graduates.map((graduate, i) => (
                                <div key={i}>
                                    <Row className="px-2">
                                        <Col lg="6">
                                            <p className="mt-5 mb-3">{graduate.description}</p>
                                            <p className="mb-0"><strong><em>{graduate.name}</em></strong></p>
                                            {graduate.sport && <p className="sport"><em>{graduate.sport}</em></p>}
                                        </Col>
                                        <Col lg="6" className="text-center">
                                            <img src={`/images/${graduate.image}.jpg`} alt={graduate.name} title={graduate.name} className="img-fluid d-inline"/>
                                        </Col>
                                    </Row>
                                </div>
                            ))}
                        </Slider>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
};

Graduates.propTypes = {
    graduates: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default Graduates;